export default {"src":"/_next/static/image/public/landing/dot_pattern.a20a6486754261fb13016dce85b2086e.svg","height":347,"width":302};